export default class {
  constructor() {
    this.removeYoutubeCookieOverlay();

    (<any>window).OneTrust.OnConsentChanged(() => this.removeYoutubeCookieOverlay());
  }

  removeYoutubeCookieOverlay() {
    const body = document.body;
    const ytGroup = body.getAttribute('data-yt-group').split(',');
    const $youtubeVideos = Array.from(
      document.getElementsByClassName('js-youtube-video-overlay-cookie')
    );

    if (ytGroup.length) {
      const isYSCAccepted = (<any>window).OnetrustActiveGroups.includes(...ytGroup);

      if (isYSCAccepted) {
        for (const video of $youtubeVideos) {
          video.classList.add('hidden');
        }
      }
      if (!isYSCAccepted) {
        for (const video of $youtubeVideos) {
          video.classList.remove('hidden');
        }
      }
    }
  }
}
